import React from 'react';
import {
  Grid
} from '@material-ui/core';
import ChromeLogo from './chrome.png';


const UnsupportedChromeNotification = () => {
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      className="mt-20"
    >
      <div className="flex-grow flex-column relative scroll-y justify-center items-center">
        <img src={ChromeLogo} alt="chrome update" width="258" />
      </div>
      <h2 className="mt-10 font-bold py-2 text-center text-deep-gray">
        Your current version of Chrome browser is out of date.
      </h2>
      <h2 className="font-bold py-2 text-center text-deep-gray">
        Please, update Chrome to version 86 or later to work in Shop Manager.
      </h2>
    </Grid>
  );
};

export default UnsupportedChromeNotification;
